<template>
    <div class="py-5 bg-white">
        <div class="white-player-playlist-controls" v-if="isMiniPlayer">
            <img class="playlist-album-art" :src="songs.length > 0 && songs[0]['cover_art_url']" />
            <div class="playlist-controls">
                <div class="playlist-meta-data">
                    <span class="song-name">{{ songs.length > 0 && songs[0]['name'] }}</span>
                    <span class="song-artist">{{ songs.length > 0 && songs[0]['artist'] }}</span>
                </div>
                <div class="playlist-control-wrapper">
                    <div id="playlist-play-pause" :class="isPlay ? 'playlist-playing-single' : 'playlist-pause-single'"
                        @click="isPlay ? pauseSound() : playSound(songs.length > 0 && songs[0]['url'])">
                        <audio id="audio-single"></audio>
                    </div>
                </div>
            </div>
        </div>
        <div class="left" v-else>
            <div id="white-player">
                <div class="navbar bg-base-100">
                <div class="navbar-start">
                    <div class="dropdown">
                    <label tabindex="0" class="btn btn-ghost btn-circle">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7" /></svg>
                    </label>
                    <ul tabindex="0" class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        <li>
                            <a :href="`/maps/${hashId}/display`">
                            <span class="material-symbols-outlined notranslate fill-current">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m600-120-240-84-186 72q-20 8-37-4.5T120-170v-560q0-13 7.5-23t20.5-15l212-72 240 84 186-72q20-8 37 4.5t17 33.5v560q0 13-7.5 23T812-192l-212 72Zm-40-98v-468l-160-56v468l160 56Zm80 0 120-40v-474l-120 46v468Zm-440-10 120-46v-468l-120 40v474Zm440-458v468-468Zm-320-56v468-468Z"/></svg>
                            </span>
                            back to Map
                            </a>
                        </li>
                        <li>
                            <div @click="showPlaylist()" class="fill-current">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M120-320v-80h320v80H120Zm0-160v-80h480v80H120Zm0-160v-80h480v80H120Zm520 520v-320l240 160-240 160Z"/></svg>
                                Audio List
                            </div>
                        </li>
                    </ul>
                    </div>
                </div>
                <div class="navbar-center">
                    <h3 class="normal-case font-title text-lg font-extrabold text-xl">Audio Guide</h3>
                </div>
                <div class="navbar-end">
                    <div @click="showPlaylist()" class="btn btn-circle btn-ghost">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M120-320v-80h320v80H120Zm0-160v-80h480v80H120Zm0-160v-80h480v80H120Zm520 520v-320l240 160-240 160Z"/></svg>
                    </div>
                </div>
                </div>
                <div id="white-player-center">
                    <img data-amplitude-song-info="cover_art_url" data-amplitude-playlist="trip_hop"
                        class="main-album-art" />

                    <div class="song-meta-data m-3 text-center">
                        <span data-amplitude-song-info="name" data-amplitude-playlist="trip_hop" class="text-base"></span>
                        <span data-amplitude-song-info="artist" data-amplitude-playlist="trip_hop"
                            class="song-artist"></span>
                    </div>
                    <div class="time-progress">
                        <div id="progress-container">
                            <input type="range" class="amplitude-song-slider" data-amplitude-playlist="trip_hop" />
                            <progress id="song-played-progress" class="amplitude-song-played-progress"
                                data-amplitude-playlist="trip_hop"></progress>
                            <progress id="song-buffered-progress" class="amplitude-buffered-progress" value="0"></progress>
                        </div>
                        <div class="time-container">
                            <span class="current-time">
                                <span class="amplitude-current-minutes" data-amplitude-playlist="trip_hop"></span>:<span
                                    class="amplitude-current-seconds" data-amplitude-playlist="trip_hop"></span>
                            </span>
                        </div>
                        <span class="duration">
                            <span class="amplitude-duration-minutes" data-amplitude-playlist="trip_hop"></span>:<span
                                class="amplitude-duration-seconds" data-amplitude-playlist="trip_hop"></span>
                        </span>
                    </div>
                </div>
                <div id="white-player-controls">
                    <div class="amplitude-shuffle amplitude-shuffle-off" data-amplitude-playlist="trip_hop" id="shuffle">
                    </div>
                    <div class="amplitude-prev" data-amplitude-playlist="trip_hop" id="previous"></div>
                    <div class="amplitude-play-pause" data-amplitude-playlist="trip_hop" id="play-pause"></div>
                    <div class="amplitude-next" data-amplitude-playlist="trip_hop" id="next"></div>
                    <div class="amplitude-repeat" data-amplitude-playlist="trip_hop" id="repeat"></div>
                </div>
                <div data-amplitude-song-info="album" data-amplitude-playlist="trip_hop"
                    class="song-artist m-3 pb-5 my-3 aligin-left" style="white-space: pre-wrap;">
                </div>
                <div id="white-player-playlist-container" :class="!isShowPlaylist ? 'slide-out-top' : 'slide-in-top'" v-show="isShowPlaylist">
                    <div class="white-player-playlist-top">
                        <div></div>
                        <div>
                            <span class="queue">Audio List</span>
                        </div>
                        <div @click="showPlaylist()">
                            <img src="/img/icon_player/close.svg" class="close-playlist">
                        </div>
                    </div>
                    <div class="white-player-playlist">
                        <div class="white-player-playlist-song amplitude-song-container amplitude-play-pause"
                            :data-amplitude-song-index="index" data-amplitude-playlist="trip_hop"
                            v-for="(song, index) in songs" :key="index">
                            <img :src="song.cover_art_url" />

                            <div class="playlist-song-meta">
                                <span class="playlist-song-name">{{ song.name }}</span>
                                <span class="playlist-artist-album">{{ song.artist }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="white-player-playlist-controls">
                        <img data-amplitude-song-info="cover_art_url" data-amplitude-playlist="trip_hop"
                            class="playlist-album-art" />
                        <div class="playlist-controls">
                            <div class="playlist-meta-data">
                                <span data-amplitude-song-info="name" data-amplitude-playlist="trip_hop"
                                    class="song-name"></span>
                                <span data-amplitude-song-info="artist" data-amplitude-playlist="trip_hop"
                                    class="song-artist"></span>
                            </div>
                            <div class="playlist-control-wrapper">
                                <div class="amplitude-prev" id="playlist-previous" data-amplitude-playlst="trip_hop">
                                </div>
                                <div class="amplitude-play-pause" data-amplitude-playlist="trip_hop"
                                    id="playlist-play-pause"></div>
                                <div class="amplitude-next" id="playlist-next" data-amplitude-playlist="trip_hop"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Amplitude from 'amplitudejs';

export default {
    props: {
        trans: {
            type: Object,
            required: true,
        },
        audioGuideData: {
            type: Object,
            default: function () {
                return null;
            }
        },
        audioGuideFiles: {
            type: Array,
            default: function () {
                return null;
            }
        },
        audioGuideTranslation: {
            type: Array,
            default: function () {
                return null;
            }
        },
        defaultLocale: {
            type: String,
            required: true
        },
        isMiniPlayer: {
            type: Boolean,
            default: function () {
                return false;
            }
        },
        hashId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            isPlay: false,
            isShowPlaylist: false,
            audioOnLocation: null
        }
    },
    methods: {
        init() {
            Amplitude.init({
                "continue_next": false,
                "songs": [{}],
                "playlists": {
                    "trip_hop": {
                        songs: this.songs
                    }
                }
            });
        },
        showPlaylist() {
            this.isShowPlaylist = !this.isShowPlaylist;
        },
        playSound(sound) {
            if (!sound) return;
            this.isPlay = true;
            this.audioOnLocation = document.getElementById("audio-single");
            this.audioOnLocation.src = sound;
            this.audioOnLocation.play();
        },
        pauseSound() {
            this.isPlay = false;
            this.audioOnLocation.pause();
        }
    },
    computed: {
        songs() {
            for (let i = 0; i < this.audioGuideFiles.length; i++) {
                const item = this.audioGuideFiles[i];
                item.audio_guide_translation = this.audioGuideTranslation.find(e => e.locale === item.language);
                if (item.language !== this.defaultLocale) {
                    continue;
                }
                this.audioGuideFiles.splice(i, 1);
                this.audioGuideFiles.unshift(item);
            }

            return this.audioGuideFiles.map((item) => {
                return {
                    name: item.audio_guide_translation ? item.audio_guide_translation.title : this.audioGuideData.title,
                    artist: this.trans[item.language],
                    album: item.audio_guide_translation ? item.audio_guide_translation.description : this.audioGuideData.description,
                    url: item.audio_guide_url,
                    cover_art_url: this.audioGuideData.image_url
                }
            });
        },
    },
    mounted() {
        this.init();
    }
}
</script>

<style>
div#white-player {
    width: 100%;
    max-width: 375px;
    background-color: #FFFFFF;
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    font-family: "Lato", sans-serif;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}

div.white-player-top {
    height: 64px;
    display: flex;
    width: 100%;
    align-items: center;
}

div.white-player-top div {
    flex: 1;
}

div.white-player-top div.center {
    text-align: center;
}

div.white-player-top span.now-playing {
    color: #414344;
    font-family: "Lato", sans-serif;
    line-height: 64px;
    font-weight: 600;
}

div.white-player-top img.show-playlist {
    float: right;
    cursor: pointer;
    margin-right: 10px;
}

div#white-player-center img.main-album-art {
    display: block;
    margin: auto;
    margin-top: 16px;
    margin-bottom: 50px;
    border-radius: 8px;
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.12);
    width: 280px;
    height: 280px;
}

div#white-player-center div.song-meta-data span.song-name {
    color: #414344;
    display: block;
    text-align: center;
    font-size: 20px;
}

div#white-player-center div.song-meta-data span.song-artist {
    color: #AAAFB3;
    display: block;
    text-align: center;
    font-size: 14px;
}

div#white-player-center div.time-progress {
    margin-bottom: 30px;
}

div#white-player-center div.time-progress span.current-time {
    color: #AAAFB3;
    font-size: 12px;
    display: block;
    float: left;
    margin-left: 20px;
}

div#white-player-center div.time-progress div#progress-container {
    margin-left: 20px;
    margin-right: 20px;
    position: relative;
    height: 20px;
    cursor: pointer;
}

div#white-player-center div.time-progress div#progress-container:hover input[type=range].amplitude-song-slider::-webkit-slider-thumb {
    display: block;
}

div#white-player-center div.time-progress div#progress-container:hover input[type=range].amplitude-song-slider::-moz-range-thumb {
    visibility: visible;
}

div#white-player-center div.time-progress div#progress-container progress#song-played-progress {
    width: 100%;
    position: absolute;
    left: 0;
    top: 8px;
    right: 0;
    width: 100%;
    z-index: 60;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 4px;
    border-radius: 5px;
    background: transparent;
    border: none;
}

@media all and (-ms-high-contrast: none) {

    div#white-player-center div.time-progress div#progress-container *::-ms-backdrop,
    div#white-player-center div.time-progress div#progress-container progress#song-played-progress {
        color: #FA6733;
        border: none;
        background-color: #E1E1E1;
    }
}

@supports (-ms-ime-align: auto) {
    div#white-player-center div.time-progress div#progress-container progress#song-played-progress {
        color: #FA6733;
        border: none;
    }
}

div#white-player-center div.time-progress div#progress-container progress#song-played-progress[value]::-webkit-progress-bar {
    background: none;
    border-radius: 5px;
}

div#white-player-center div.time-progress div#progress-container progress#song-played-progress[value]::-webkit-progress-value {
    background-color: #FA6733;
    border-radius: 5px;
}

div#white-player-center div.time-progress div#progress-container progress#song-played-progress::-moz-progress-bar {
    background: none;
    border-radius: 5px;
    background-color: #FA6733;
    height: 5px;
    margin-top: -2px;
}

div#white-player-center div.time-progress div#progress-container progress#song-buffered-progress {
    position: absolute;
    left: 0;
    top: 8px;
    right: 0;
    width: 100%;
    z-index: 10;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 4px;
    border-radius: 5px;
    background: transparent;
    border: none;
    background-color: #D7DEE3;
}

div#white-player-center div.time-progress div#progress-container progress#song-buffered-progress[value]::-webkit-progress-bar {
    background-color: #E1E1E1;
    border-radius: 5px;
}

div#white-player-center div.time-progress div#progress-container progress#song-buffered-progress[value]::-webkit-progress-value {
    background-color: #E1E1E1;
    border-radius: 5px;
    transition: width .1s ease;
}

div#white-player-center div.time-progress div#progress-container progress#song-buffered-progress::-moz-progress-bar {
    background: none;
    border-radius: 5px;
    background-color: #E1E1E1;
    height: 5px;
    margin-top: -2px;
}

div#white-player-center div.time-progress div#progress-container progress::-ms-fill {
    border: none;
}

@-moz-document url-prefix() {
    div#white-player-center div.time-progress div#progress-container progress#song-buffered-progress {
        top: 9px;
        border: none;
    }
}

@media all and (-ms-high-contrast: none) {

    div#white-player-center div.time-progress div#progress-container *::-ms-backdrop,
    div#white-player-center div.time-progress div#progress-container progress#song-buffered-progress {
        color: #78909C;
        border: none;
    }
}

@supports (-ms-ime-align: auto) {
    div#white-player-center div.time-progress div#progress-container progress#song-buffered-progress {
        color: #78909C;
        border: none;
    }
}

div#white-player-center div.time-progress div#progress-container input[type=range] {
    -webkit-appearance: none;
    width: 100%;
    margin: 7.5px 0;
    position: absolute;
    z-index: 9999;
    top: -7px;
    height: 20px;
    cursor: pointer;
    background-color: inherit;
}

div#white-player-center div.time-progress div#progress-container input[type=range]:focus {
    outline: none;
}

div#white-player-center div.time-progress div#progress-container input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 0px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: #FA6733;
    border-radius: 0px;
    border: 0px solid #010101;
}

div#white-player-center div.time-progress div#progress-container input[type=range]::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 1px solid #FA6733;
    height: 15px;
    width: 15px;
    border-radius: 16px;
    background: #FA6733;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -7.5px;
}

div#white-player-center div.time-progress div#progress-container input[type=range]:focus::-webkit-slider-runnable-track {
    background: #FA6733;
}

div#white-player-center div.time-progress div#progress-container input[type=range]::-moz-range-track {
    width: 100%;
    height: 0px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: #FA6733;
    border-radius: 0px;
    border: 0px solid #010101;
}

div#white-player-center div.time-progress div#progress-container input[type=range]::-moz-range-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 1px solid #FA6733;
    height: 15px;
    width: 15px;
    border-radius: 16px;
    background: #FA6733;
    cursor: pointer;
}

div#white-player-center div.time-progress div#progress-container input[type=range]::-ms-track {
    width: 100%;
    height: 0px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
}

div#white-player-center div.time-progress div#progress-container input[type=range]::-ms-fill-lower {
    background: #003d57;
    border: 0px solid #010101;
    border-radius: 0px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
}

div#white-player-center div.time-progress div#progress-container input[type=range]::-ms-fill-upper {
    background: #FA6733;
    border: 0px solid #010101;
    border-radius: 0px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
}

div#white-player-center div.time-progress div#progress-container input[type=range]::-ms-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 1px solid #FA6733;
    height: 15px;
    width: 15px;
    border-radius: 16px;
    background: #FA6733;
    cursor: pointer;
    height: 0px;
    display: none;
}

@media all and (-ms-high-contrast: none) {

    div#white-player-center div.time-progress div#progress-container *::-ms-backdrop,
    div#white-player-center div.time-progress div#progress-container input[type="range"].amplitude-song-slider {
        padding: 0px;
    }

    div#white-player-center div.time-progress div#progress-container *::-ms-backdrop,
    div#white-player-center div.time-progress div#progress-container input[type=range].amplitude-song-slider::-ms-thumb {
        height: 15px;
        width: 15px;
        border-radius: 10px;
        cursor: pointer;
        margin-top: -8px;
    }

    div#white-player-center div.time-progress div#progress-container *::-ms-backdrop,
    div#white-player-center div.time-progress div#progress-container input[type=range].amplitude-song-slider::-ms-track {
        border-width: 15px 0;
        border-color: transparent;
    }

    div#white-player-center div.time-progress div#progress-container *::-ms-backdrop,
    div#white-player-center div.time-progress div#progress-container input[type=range].amplitude-song-slider::-ms-fill-lower {
        background: #E1E1E1;
        border-radius: 10px;
    }

    div#white-player-center div.time-progress div#progress-container *::-ms-backdrop,
    div#white-player-center div.time-progress div#progress-container input[type=range].amplitude-song-slider::-ms-fill-upper {
        background: #E1E1E1;
        border-radius: 10px;
    }
}

@supports (-ms-ime-align: auto) {
    div#white-player-center div.time-progress div#progress-container input[type=range].amplitude-song-slider::-ms-thumb {
        height: 15px;
        width: 15px;
        margin-top: 3px;
    }
}

div#white-player-center div.time-progress div#progress-container input[type=range]:focus::-ms-fill-lower {
    background: #FA6733;
}

div#white-player-center div.time-progress div#progress-container input[type=range]:focus::-ms-fill-upper {
    background: #FA6733;
}

div#white-player-center div.time-progress span.duration {
    color: #AAAFB3;
    font-size: 12px;
    display: block;
    float: right;
    margin-right: 20px;
}

div#white-player-controls {
    text-align: center;
    padding-bottom: 35px;
}

div#white-player-controls div#shuffle {
    display: inline-block;
    width: 19px;
    height: 16px;
    cursor: pointer;
    vertical-align: middle;
    margin-right: 24px;
}

div#white-player-controls div#shuffle.amplitude-shuffle-off {
    background: url("/img/icon_player/shuffle-off.svg");
}

div#white-player-controls div#shuffle.amplitude-shuffle-on {
    background: url("/img/icon_player/shuffle-on.svg");
}

div#white-player-controls div#previous {
    display: inline-block;
    height: 53px;
    width: 53px;
    cursor: pointer;
    background: url("/img/icon_player/previous.svg");
    vertical-align: middle;
    margin-right: 16px;
}

div#white-player-controls div#play-pause {
    display: inline-block;
    width: 85px;
    height: 85px;
    cursor: pointer;
    vertical-align: middle;
    margin-right: 16px;
}

div#white-player-controls div#play-pause.amplitude-paused {
    background: url("/img/icon_player/play.svg");
}

div#white-player-controls div#play-pause.amplitude-playing {
    background: url("/img/icon_player/pause.svg");
}

div#white-player-controls div#next {
    display: inline-block;
    height: 53px;
    width: 53px;
    cursor: pointer;
    background: url("/img/icon_player/next.svg");
    vertical-align: middle;
    margin-right: 24px;
}

div#white-player-controls div#repeat {
    display: inline-block;
    width: 18px;
    height: 16px;
    cursor: pointer;
    vertical-align: middle;
}

div#white-player-controls div#repeat.amplitude-repeat-off {
    background: url("/img/icon_player/repeat-off.svg");
}

div#white-player-controls div#repeat.amplitude-repeat-on {
    background: url("/img/icon_player/repeat-on.svg");
}

div#white-player-playlist-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: white;
    z-index: 9999;
    display: none;
    border-radius: 8px;
    display: block;
}

div.white-player-playlist-top {
    height: 64px;
    text-align: center;
    display: flex;
}

div.white-player-playlist-top div {
    flex: 1;
}

div.white-player-playlist-top div span.queue {
    color: #414344;
    font-family: "Lato", sans-serif;
    line-height: 64px;
    font-weight: 600;
}

div.white-player-playlist-top div img.close-playlist {
    margin-right: 16px;
    margin-top: 22px;
    float: right;
    cursor: pointer;
}

div.white-player-up-next {
    margin-top: 6px;
    padding-left: 20px;
    font-size: 24px;
    color: #414344;
}

div.white-player-playlist {
    margin-top: 32px;
    height: calc(100% - 234px);
    overflow-y: scroll;
}

div.white-player-playlist-song {
    border-bottom: 1px solid #F5F5F6;
    padding-top: 8px;
    padding-bottom: 8px;
    cursor: pointer;
}

div.white-player-playlist-song:hover {
    background-color: #ebebeb;
}

div.white-player-playlist-song.amplitude-active-song-container {
    background-color: #dddddd;
}

div.white-player-playlist-song img {
    width: 48px;
    height: 48px;
    border-radius: 3px;
    margin-left: 16px;
    float: left;
}

div.white-player-playlist-song div.playlist-song-meta {
    float: left;
    margin-left: 15px;
    width: calc(100% - 80px);
}

div.white-player-playlist-song div.playlist-song-meta span.playlist-song-name {
    color: #414344;
    font-size: 14px;
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

div.white-player-playlist-song div.playlist-song-meta span.playlist-artist-album {
    color: #AAAFB3;
    font-size: 12px;
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

div.white-player-playlist-song::after {
    content: "";
    display: table;
    clear: both;
}

div.white-player-playlist-controls {
    background-color: #F5F5F6;
    border-radius: 8px;
    padding: 16px;
}

div.white-player-playlist-controls img.playlist-album-art {
    float: left;
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    height: 64px;
    width: 64px;
}

div.white-player-playlist-controls div.playlist-controls {
    float: left;
    margin-left: 25px;
    width: calc(100% - 89px);
}

div.white-player-playlist-controls div.playlist-controls div.playlist-meta-data {
    display: inline-block;
    width: calc(100% - 125px);
    vertical-align: middle;
}

div.white-player-playlist-controls div.playlist-controls div.playlist-meta-data span.song-name {
    display: block;
    color: #414344;
    font-size: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

div.white-player-playlist-controls div.playlist-controls div.playlist-meta-data span.song-artist {
    display: block;
    color: #AAAFB3;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

div.white-player-playlist-controls div.playlist-controls div.playlist-control-wrapper {
    text-align: center;
    margin-top: 10px;
    display: inline-block;
    width: 120px;
    vertical-align: middle;
}

div.white-player-playlist-controls div.playlist-controls div.playlist-control-wrapper div#playlist-previous {
    display: inline-block;
    height: 32px;
    width: 32px;
    cursor: pointer;
    background: url("/img/icon_player/previous.svg");
    vertical-align: middle;
    background-size: 32px 32px;
}

div.white-player-playlist-controls div.playlist-controls div.playlist-control-wrapper div#playlist-play-pause {
    display: inline-block;
    width: 32px;
    height: 32px;
    cursor: pointer;
    vertical-align: middle;
}

div.white-player-playlist-controls div.playlist-controls div.playlist-control-wrapper div#playlist-play-pause.amplitude-paused {
    background: url("/img/icon_player/play.svg");
    background-size: 32px 32px;
}

div.white-player-playlist-controls div.playlist-controls div.playlist-control-wrapper div#playlist-play-pause.amplitude-playing {
    background: url("/img/icon_player/pause.svg");
    background-size: 32px 32px;
}

div.white-player-playlist-controls div.playlist-controls div.playlist-control-wrapper div#playlist-next {
    display: inline-block;
    height: 32px;
    width: 32px;
    cursor: pointer;
    background: url("/img/icon_player/next.svg");
    vertical-align: middle;
    background-size: 32px 32px;
}

div.white-player-playlist-controls::after {
    content: "";
    display: table;
    clear: both;
}

div#black-player {
    width: 100%;
    max-width: 375px;
    background-color: #333333;
    box-shadow: 0px 12px 24px rgba(0, 0, 0, 0.12);
    font-family: "Lato", sans-serif;
    margin: auto;
    margin-right: 50px;
    margin-top: 50px;
}

div#black-player-playlist {
    height: 400px;
    overflow-y: scroll;
}

div#black-player-controls {
    height: 130px;
}

div#black-player-controls img.playlist-album-art {
    float: left;
    width: 130px;
    height: 130px;
}

div#black-player-controls div.black-player-controls-container {
    float: left;
    width: calc(100% - 150px);
    margin-left: 20px;
    text-align: center;
}

div#black-player-controls div.black-player-controls-container span.song-name {
    display: block;
    color: white;
    font-size: 14px;
    text-align: left;
}

div#black-player-controls div.black-player-controls-container span.song-artist {
    display: block;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    text-align: left;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black {
    margin-right: 20px;
    position: relative;
    height: 20px;
    cursor: pointer;
    margin-bottom: 6px;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black:hover input[type=range].amplitude-song-slider::-webkit-slider-thumb {
    display: block;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black:hover input[type=range].amplitude-song-slider::-moz-range-thumb {
    visibility: visible;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-played-progress-black {
    width: 100%;
    position: absolute;
    left: 0;
    top: 8px;
    right: 0;
    width: 100%;
    z-index: 60;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 3px;
    border-radius: 5px;
    background: transparent;
    border: none;
}

@media all and (-ms-high-contrast: none) {

    div#black-player-controls div.black-player-controls-container div#progress-container-black *::-ms-backdrop,
    div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-played-progress-black {
        color: #FFFFFF;
        border: none;
        background-color: #E1E1E1;
    }
}

@supports (-ms-ime-align: auto) {
    div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-played-progress-black {
        color: #FFFFFF;
        border: none;
    }
}

div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-played-progress-black[value]::-webkit-progress-bar {
    background: none;
    border-radius: 5px;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-played-progress-black[value]::-webkit-progress-value {
    background-color: #FFFFFF;
    border-radius: 5px;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-played-progress-black::-moz-progress-bar {
    background: none;
    border-radius: 5px;
    background-color: #FFFFFF;
    height: 3px;
    margin-top: -2px;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-buffered-progress-black {
    position: absolute;
    left: 0;
    top: 8px;
    right: 0;
    width: 100%;
    z-index: 10;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    height: 3px;
    border-radius: 5px;
    background: transparent;
    border: none;
    background-color: #D7DEE3;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-buffered-progress-black[value]::-webkit-progress-bar {
    background-color: #E1E1E1;
    border-radius: 5px;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-buffered-progress-black[value]::-webkit-progress-value {
    background-color: #E1E1E1;
    border-radius: 5px;
    transition: width .1s ease;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-buffered-progress-black::-moz-progress-bar {
    background: none;
    border-radius: 5px;
    background-color: #E1E1E1;
    height: 3px;
    margin-top: -2px;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black progress::-ms-fill {
    border: none;
}

@-moz-document url-prefix() {
    div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-buffered-progress-black {
        top: 9px;
        border: none;
    }
}

@media all and (-ms-high-contrast: none) {

    div#black-player-controls div.black-player-controls-container div#progress-container-black *::-ms-backdrop,
    div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-buffered-progress-black {
        color: #78909C;
        border: none;
    }
}

@supports (-ms-ime-align: auto) {
    div#black-player-controls div.black-player-controls-container div#progress-container-black progress#song-buffered-progress-black {
        color: #78909C;
        border: none;
    }
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range] {
    -webkit-appearance: none;
    width: 100%;
    margin: 7.5px 0;
    position: absolute;
    z-index: 9999;
    top: -7px;
    height: 20px;
    cursor: pointer;
    background-color: inherit;
    left: 0;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]:focus {
    outline: none;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 0px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: #FFFFFF;
    border-radius: 0px;
    border: 0px solid #010101;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]::-webkit-slider-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 1px solid #FFFFFF;
    height: 15px;
    width: 15px;
    border-radius: 16px;
    background: #FFFFFF;
    cursor: pointer;
    -webkit-appearance: none;
    margin-top: -7.5px;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]:focus::-webkit-slider-runnable-track {
    background: #FFFFFF;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]::-moz-range-track {
    width: 100%;
    height: 0px;
    cursor: pointer;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
    background: #FFFFFF;
    border-radius: 0px;
    border: 0px solid #010101;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]::-moz-range-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 1px solid #FFFFFF;
    height: 15px;
    width: 15px;
    border-radius: 16px;
    background: #FFFFFF;
    cursor: pointer;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]::-ms-track {
    width: 100%;
    height: 0px;
    cursor: pointer;
    background: transparent;
    border-color: transparent;
    color: transparent;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]::-ms-fill-lower {
    background: #003d57;
    border: 0px solid #010101;
    border-radius: 0px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]::-ms-fill-upper {
    background: #FFFFFF;
    border: 0px solid #010101;
    border-radius: 0px;
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0);
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]::-ms-thumb {
    box-shadow: 0px 0px 0px #000000, 0px 0px 0px #0d0d0d;
    border: 1px solid #FFFFFF;
    height: 15px;
    width: 15px;
    border-radius: 16px;
    background: #FFFFFF;
    cursor: pointer;
    height: 0px;
    display: none;
}

@media all and (-ms-high-contrast: none) {

    div#black-player-controls div.black-player-controls-container div#progress-container-black *::-ms-backdrop,
    div#black-player-controls div.black-player-controls-container div#progress-container-black input[type="range"].amplitude-song-slider {
        padding: 0px;
    }

    div#black-player-controls div.black-player-controls-container div#progress-container-black *::-ms-backdrop,
    div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range].amplitude-song-slider::-ms-thumb {
        height: 15px;
        width: 15px;
        border-radius: 10px;
        cursor: pointer;
        margin-top: -8px;
    }

    div#black-player-controls div.black-player-controls-container div#progress-container-black *::-ms-backdrop,
    div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range].amplitude-song-slider::-ms-track {
        border-width: 15px 0;
        border-color: transparent;
    }

    div#black-player-controls div.black-player-controls-container div#progress-container-black *::-ms-backdrop,
    div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range].amplitude-song-slider::-ms-fill-lower {
        background: #E1E1E1;
        border-radius: 10px;
    }

    div#black-player-controls div.black-player-controls-container div#progress-container-black *::-ms-backdrop,
    div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range].amplitude-song-slider::-ms-fill-upper {
        background: #E1E1E1;
        border-radius: 10px;
    }
}

@supports (-ms-ime-align: auto) {
    div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range].amplitude-song-slider::-ms-thumb {
        height: 15px;
        width: 15px;
        margin-top: 3px;
    }
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]:focus::-ms-fill-lower {
    background: #FFFFFF;
}

div#black-player-controls div.black-player-controls-container div#progress-container-black input[type=range]:focus::-ms-fill-upper {
    background: #FFFFFF;
}

div#black-player-controls div.black-player-controls-container div#shuffle-black {
    display: inline-block;
    width: 15px;
    height: 14px;
    cursor: pointer;
    vertical-align: middle;
    margin-right: 25px;
    margin-left: -16px;
}

div#black-player-controls div.black-player-controls-container div#shuffle-black.amplitude-shuffle-off {
    background: url("/img/icon_player/black-shuffle-off.svg");
}

div#black-player-controls div.black-player-controls-container div#shuffle-black.amplitude-shuffle-on {
    background: url("/img/icon_player/black-shuffle-on.svg");
}

div#black-player-controls div.black-player-controls-container div#previous-black {
    display: inline-block;
    height: 19px;
    width: 16px;
    cursor: pointer;
    background: url("/img/icon_player/black-previous.svg");
    vertical-align: middle;
    margin-right: 10px;
}

div#black-player-controls div.black-player-controls-container div#play-pause-black {
    display: inline-block;
    width: 52px;
    height: 52px;
    cursor: pointer;
    vertical-align: middle;
    margin-right: 10px;
}

div#black-player-controls div.black-player-controls-container div#play-pause-black.amplitude-paused {
    background: url("/img/icon_player/black-play.svg");
}

div#black-player-controls div.black-player-controls-container div#play-pause-black.amplitude-playing {
    background: url("/img/icon_player/black-pause.svg");
}

div#black-player-controls div.black-player-controls-container div#next-black {
    display: inline-block;
    height: 19px;
    width: 16px;
    cursor: pointer;
    background: url("/img/icon_player/black-next.svg");
    vertical-align: middle;
    margin-right: 25px;
}

div#black-player-controls div.black-player-controls-container div#repeat-black {
    display: inline-block;
    width: 15px;
    height: 16px;
    cursor: pointer;
    vertical-align: middle;
}

div#black-player-controls div.black-player-controls-container div#repeat-black.amplitude-repeat-off {
    background: url("/img/icon_player/black-repeat-off.svg");
}

div#black-player-controls div.black-player-controls-container div#repeat-black.amplitude-repeat-on {
    background: url("/img/icon_player/black-repeat-on.svg");
}

div.black-player-song {
    border-bottom: 1px solid #979797;
}

div.black-player-song img {
    height: 52px;
    width: 52px;
    float: left;
}

div.black-player-song div.song-meta-container {
    width: calc(100% - 62px);
    float: left;
    padding-left: 10px;
}

div.black-player-song div.song-meta-container span.individual-song-name {
    display: block;
    color: white;
    font-size: 14px;
    font-weight: bold;
}

div.black-player-song div.song-meta-container span.individual-song-artist {
    display: block;
    color: rgba(255, 255, 255, 0.7);
    font-size: 13px;
}

div.black-player-song.amplitude-active-song-container div.song-meta-container span.individual-song-name {
    color: #2EBD59;
}

div.black-player-song::after {
    content: "";
    display: table;
    clear: both;
}

.slide-in-top {
    -webkit-animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@-webkit-keyframes slide-in-top {
    0% {
        -webkit-transform: translateY(-10px);
        transform: translateY(-10px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slide-in-top {
    0% {
        -webkit-transform: translateY(-10px);
        transform: translateY(-10px);
        opacity: 0;
    }

    100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }
}

.slide-out-top {
    -webkit-animation: slide-out-top 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
    animation: slide-out-top 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

@-webkit-keyframes slide-out-top {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        -webkit-transform: translateY(-10px);
        transform: translateY(-10px);
        opacity: 0;
    }
}

@keyframes slide-out-top {
    0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        -webkit-transform: translateY(-10px);
        transform: translateY(-10px);
        opacity: 0;
    }
}

.playlist-pause-single {
    display: inline-block;
    width: 32px;
    height: 32px;
    cursor: pointer;
    vertical-align: middle;
    background: url(/img/icon_player/play.svg);
    background-size: 32px 32px;
}

.playlist-playing-single {
    display: inline-block;
    width: 32px;
    height: 32px;
    cursor: pointer;
    vertical-align: middle;
    background: url(/img/icon_player/pause.svg);
    background-size: 32px 32px;
}

.back-map {
    float: left;
    cursor: pointer;
    margin-left: 10px;
}
</style>